import React from 'react'

export default function IcoTelegram( props ) {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 24"
      { ...props }
    >
      <path d="M21.9 4.3c.3-1.2-.9-2.2-2-1.7L2.6 9.4c-1.3.5-1.2 2.4.1 2.8l4.3 1.3 1.6 5.2c.2.7 1.1.9 1.6.3l2.4-2.5 4.5 3.3c.8.6 2 .2 2.2-.8l2.6-14.7zM8.9 13.4l8.3-5.2c.2-.1.4.2.2.3l-6.7 6.3c-.2.2-.4.5-.4.8l-.2 2.3-1.2-3.9c-.1-.3 0-.7.2-.9z" />
    </svg>
  )
}
